import { useState, useEffect } from 'react';
import { getStorageItem, setStorageItem } from '@util/storage';

export const useStateWithStorage = (
  storageType,
  storageKey,
  defaultValue,
  encrypt = process.env.ENABLE_DEV_FEATURES === 'true'
) => {
  const [value, setValue] = useState(() =>
    getStorageItem(storageType, storageKey, defaultValue, encrypt)
  );

  useEffect(() => {
    setStorageItem(storageType, storageKey, value, encrypt);
  }, [value, encrypt, storageKey, storageType]);

  return [value, setValue];
};
